export function addCloudinaryBlurredBackgroundPadding(
  imageUrl: string,
  height: number,
  width: number,
  blur: number,
  opacity: number,
  aspectRatio: number
): string {
  if (!imageUrl || !imageUrl.includes('/upload/')) {
    // Return the original image URL if it doesn't contain '/upload/'
    return imageUrl;
  }

  // Split the URL to find the section before and after '/upload/'
  const urlParts = imageUrl.split('/upload/');
  const baseurl = urlParts[0];
  const publicID = urlParts[1];
  const transformationPath = publicID.replace('/', ':');

  // Define the transformation string
  const transformations = `c_pad,h_${height},w_${width}/ar_${aspectRatio},c_scale,e_blur:${blur},h_${height},o_${opacity},u_${transformationPath},w_${width}/fl_layer_apply`;

  // Rebuild the URL with transformations inserted
  return `${baseurl}/upload/${transformations}/${publicID}`;
}
